module.exports = __webpack_public_path__ + "img/screen-manual-21.19722c6e.png";